'use client';

import { useEffect, useState } from 'react';
import { inIframe, isWebview } from './app/helpers';
import { useTranslate } from '@tolgee/react';

const Cookies = () => {
  // Third party hooks
  const { t } = useTranslate();

  //States
  const [preferences, setPreferences] = useState<boolean>(false);
  const [hidden, setHidden] = useState<boolean>(true);

  useEffect(() => {
    setHidden(localStorage.getItem('analytics') === 'true');
  }, []);

  if (hidden) {
    return <></>;
  }

  return (
    !inIframe() &&
    !isWebview() && (
      <>
        <div className='fixed bottom-0 left-0 right-0 z-50 flex flex-col justify-center gap-3 bg-white/90 px-6 py-5 text-gray-800 backdrop-blur-lg md:flex-row md:items-center'>
          <svg
            className='h-5 w-5 min-w-5 text-gray-800'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='currentColor'
          >
            <path d='M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm-1 14.93a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm-3-3a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm6 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm3-3a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm-6-3a1 1 0 1 1 1-1 1 1 0 0 1-1 1z' />
          </svg>
          <p className=' text-gray-800 '>
            {t('cookies.text')}
            <a
              target='_blank'
              className='ml-2 underline'
              href='https://www.fisify.com/politica-de-privacidad/'
              rel='noreferrer'
            >
              {t('cookies.privacyPolicy')}
            </a>
          </p>
          <div className='flex items-center gap-4 md:ml-2 md:flex-row-reverse'>
            {preferences ? (
              <button
                className='rounded-xl bg-gray-800 px-6 py-4 text-sm text-white md:min-w-[250px]'
                onClick={acceptRequired}
              >
                {t('cookies.acceptRequired')}
              </button>
            ) : (
              <>
                <button
                  className='min-w-[180px] rounded-xl bg-indigo-400 px-6 py-4 font-semibold text-white'
                  onClick={acceptAll}
                >
                  {t('cookies.acceptAndClose')}
                </button>
                <p
                  className='cursor-pointer font-medium tracking-tight text-gray-600'
                  onClick={() => setPreferences(true)}
                >
                  {t('cookies.configure')}
                </p>
              </>
            )}
          </div>
        </div>
      </>
    )
  );

  function acceptAll() {
    localStorage.setItem('analytics', 'true');
    setHidden(true);
  }

  function acceptRequired() {
    localStorage.setItem('analytics', 'false');
    setPreferences(false);
    setHidden(true);
  }
};

export default Cookies;
